import React from 'react';
import { Switch } from "react-router-dom";
//import PanelRoute from 'utils/lnk-panel/route';

class LeftRouter extends React.Component {
  render() {
    return (
      <Switch>
      </Switch>
    )
  }
}

export default LeftRouter;
